import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { CheckboxControlled } from '@kubit/web-ui-product-components';
// Configurations
import { checkboxConfigurationPropsConversion } from './configurations/checkbox.configurations';
// Hooks
const CheckboxComponent = (props) => {
    return (_jsx(CheckboxControlled, { ...checkboxConfigurationPropsConversion({ ...props, onChange: props.onChange }) }));
};
export { CheckboxComponent };
//# sourceMappingURL=checkbox.component.js.map